module.exports = __webpack_public_path__ + "img/7.abd29718.jpg";